import React from "react";

const StatusBadge: React.FC<{ active: boolean }> = ({ active }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded ${
      active ? "bg-green-100 text-green-700" : "bg-gray-200 text-gray-600"
    }`}
  >
    <span
      className={`w-1.5 h-1.5 rounded-full ${active ? "bg-green-500" : "bg-gray-400"}`}
    />
    {active ? "active" : "inactive"}
  </span>
);

export default StatusBadge;
